import {
  PageSection,
  Spinner,
  Tab,
  Tabs,
  TabTitleText,
  Title,
} from '@patternfly/react-core'
import * as React from 'react'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import type { AppState } from '@app/state'
import * as ProgramScreenState from '@app/state/program_screen/state'
import { TabContent } from '@app/utils/styles/tab-content'

import { ConfiguredInteractions } from './program/program-configured-interactions'
import { ProgramPatientList } from './program/program-patient-list'
import { ProgramStats } from './program/program-status-summary'

interface UrlParams {
  id: string
}

enum TabKeys {
  Overview,
  Enrolment,
  Interactions,
}

export const ProgramSummaryScreen = () => {
  const dispatch = useDispatch()
  const { id } = useParams<UrlParams>()

  const [activeTabKey, setActiveTabKey] = useState<number>(TabKeys.Overview)

  const setActiveTab = useCallback((_, selectedTab) => {
    setActiveTabKey(selectedTab)
  }, [])

  const { loadedProgram } = useSelector<AppState, ProgramScreenState.State>(
    (state) => state.programScreen,
  )
  useEffect(() => {
    dispatch(ProgramScreenState.actions.loadProgram(id))
  }, [dispatch, id])

  const isLoading = !loadedProgram || loadedProgram.programId !== id

  return (
    <PageSection className="pf-m-light">
      {isLoading ? (
        <div>
          <Spinner size="sm" />
        </div>
      ) : (
        <>
          <Title headingLevel="h1" size="xl">
            Program: {loadedProgram?.name}
          </Title>
          <Tabs
            activeKey={activeTabKey}
            onSelect={setActiveTab}
            aria-label="Program Tabs"
            role="region"
          >
            <Tab
              eventKey={TabKeys.Overview}
              title={<TabTitleText>Overview</TabTitleText>}
            />
            <Tab
              eventKey={TabKeys.Enrolment}
              title={<TabTitleText>Enrolment</TabTitleText>}
            />
            <Tab
              eventKey={TabKeys.Interactions}
              title={<TabTitleText>Interactions</TabTitleText>}
            />
          </Tabs>
          <TabContent>
            {activeTabKey === TabKeys.Overview ? (
              <ProgramStats program={loadedProgram} />
            ) : activeTabKey === TabKeys.Enrolment ? (
              <ProgramPatientList program={loadedProgram} />
            ) : activeTabKey === TabKeys.Interactions ? (
              <ConfiguredInteractions program={loadedProgram} />
            ) : (
              <div>Interactions placeholder</div>
            )}
          </TabContent>
        </>
      )}
    </PageSection>
  )
}
